import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { JEOPARDY_URLS } from 'constants.js'
import { featureTypes } from 'constants/mydrive'
import { emitToggleMyDrive } from 'helpers/events'
import {
    ROOM_STATE,
    IFRAME,
    VIDEO_CALL,
} from 'services/webSockets/roomState/constants'
import { dispatchSendSocketMessage } from 'store/dispatcher'
import { _isStudent } from 'store/selectors/User'
import { _iframeShareUrl, _isIframeShared } from 'store/selectors/WebSocket'
import { logger } from 'utils/logger'

export default function useIframeShare({ isArtefactMode }) {
    const isLinkShared = useSelector(_isIframeShared)

    const isStudent = useSelector(_isStudent)

    const shareIframe = useCallback(urlData => {
        try {
            const roomStateData = {
                action: ROOM_STATE,
                state: IFRAME,
                data: urlData,
            }
            dispatchSendSocketMessage(roomStateData)
        } catch (error) {
            logger.error({ msg: 'Failed to start iframe sharing', error })
        }
    }, [])

    const stopShareIframe = useCallback(() => {
        try {
            const roomStateData = {
                action: ROOM_STATE,
                state: VIDEO_CALL,
            }
            dispatchSendSocketMessage(roomStateData)
        } catch (error) {
            logger.error({ msg: 'Failed to stop iframe sharing', error })
        }
    }, [])

    const iframeShareUrl = useSelector(_iframeShareUrl)
    const isIframeShared =
        isLinkShared &&
        iframeShareUrl?.student_url === JEOPARDY_URLS.STUDENT_URL

    const isIFrameDisabled = (isArtefactMode && !isIframeShared) || isStudent

    const shareIframeLink = () =>
        emitToggleMyDrive({ state: true, type: featureTypes.JEOPARDY })

    const toggleIframeShare = () => {
        if (isIframeShared) {
            stopShareIframe()
        } else {
            shareIframeLink()
        }
    }

    return {
        isIframeShared,
        isIFrameDisabled,
        toggleIframeShare,
        shareIframeLink,
        stopShareIframe,
    }
}
